import { UseMutationOptions, useMutation, useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";

/** Admin Console > User Management (admin only). */
export const USER_MANAGEMENT_API = "v1/admin/user-management";

const clean = (params: Record<string, any>) =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));

const useUmQuery = (key: string, path: string, params: Record<string, any>): UseQueryResult<any> =>
  useQuery({
    queryKey: ["user-management", key, params],
    queryFn: () => axiosAuth.get(`${USER_MANAGEMENT_API}/${path}`, { params: clean(params) }),
    select: (data: any) => data.data?.data,
    refetchOnWindowFocus: false,
  });

export const useUserManagementSummary = (params: { communityId?: string }) => useUmQuery("summary", "summary", params);
export const useUserAccounts = (params: Record<string, any>) => useUmQuery("accounts", "accounts", params);
export const useLoginActivity = (params: Record<string, any>) => useUmQuery("login-activity", "login-activity", params);
export const useActiveSessions = (params: Record<string, any>) => useUmQuery("sessions", "sessions", params);
export const usePasswordResetHistory = (params: Record<string, any>) => useUmQuery("password-resets", "password-resets", params);

export const useRevokeSessionMutation = (
  queryParams?: UseMutationOptions<any, Error, { sessionId: string; reason?: string }, unknown>
) =>
  useMutation({
    mutationFn: async ({ sessionId, reason }: { sessionId: string; reason?: string }) =>
      await axiosAuth.post(`${USER_MANAGEMENT_API}/sessions/${sessionId}/revoke`, null, { params: clean({ reason }) }),
    ...queryParams,
  });
